export default (formElements: any[]) =>
  formElements.reduce((prevValue: any, element: HTMLInputElement) => {
    prevValue[element.name] = element.value

    return prevValue
  }, {})
